import React from 'react';

import {
  Block,
} from 'framework7-react';

import AppstorePage from '../components/AppstorePage';

const Search = () => {
  return (
    <AppstorePage title="Search">
      <Block>Work in progress</Block>
    </AppstorePage>
  );
};

export default Search;
